export const stripeCardNumberId = 'stripe-card-number'

export const stripeCardExpirationId = 'stripe-card-expiration'

export const stripeCardSecurityCodeId = 'stripe-card-security_code'
